<template>
    <transition name="modal" enter-active-class="animated fadeIn" appear>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body m-0">
                        <slot name="body">
                            <div class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-check color-magenta2-light"></i>
                                <input id="titleFolder" class="form-control" type="text" v-model="taskFolderItemModel.title" autofocus placeholder="عنوان">
                            </div>
                        </slot>
                    </div>
                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">
                            <button :disabled="Loading" class="btn btn-xxs rounded-s bg-green2-light" @click="SaveFolder">
                                <i class="fa fa-check ml-2"></i>
                                ثبت
                            </button>
                            <button class="btn btn-xxs rounded-s bg-red1-light" @click="$emit('close')">
                                <i class="fa fa-times ml-2"></i>
                                بستن
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>



</template>
<script>

    export default {
       
        props: ['taskFolderItem'],
        data() {
            return {
                taskFolderItemModel: {
                    seq: 0,
                    title: null,
                    done: false,
                    disabled: false,
                    edited: false,
                    editing: false,
                    taskFolderId: 0,
                    taskFolderItemId: 0,
                    taskFolderItemTempId:0
                },
                Loading: false,
                errorMsg: null,
                readOnly:false
            };
        },
      
        mounted() {
            this.taskFolderItemModel = this.taskFolderItem;
            document.getElementById("titleFolder").focus();

        },
        methods: {
           
            SaveFolder() {
                this.Loading = true;
                this.$emit('saveFolder', this.taskFolderItemModel);
            }
        }

    };
</script>
<style>
       .modal-mask {
           position: fixed;
           z-index: 1;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           background-color: rgba(0, 0, 0, 0.5);
           display: table;
           transition: opacity 0.3s ease;
       }

       .modal-wrapper {
           display: table-cell;
           vertical-align: middle;
       }

       .modal-container {
           width: 300px;
           margin: 0px auto;
           background-color: #fff;
           border-radius: 2px;
           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
           transition: all 0.3s ease;
       }

       .modal-header h3 {
           margin-top: 0;
           color: #42b983;
       }

       .modal-body {
           margin: 20px 0;
           line-height: 1;
       }

       .modal-default-button {
           float: right;
       }


       .modal-enter {
           opacity: 0;
       }

       .modal-leave-active {
           opacity: 0;
       }

           .modal-enter .modal-container,
           .modal-leave-active .modal-container {
               -webkit-transform: scale(2);
               transform: scale(2);
           }
</style>
